import { useAccountComments } from "@portal/api/comments";
import { useAccountFollowers } from "@portal/api/followers";
import { messageDraftKey } from "@portal/components/features/message-draft";
import { CommentsSection } from "@portal/components/layout/CommentsSection";
import { CenteredSpinner } from "@portal/components/ui/CenteredSpinner";
import { AdminFollowerControls } from "../../../../admin/shared/AdminFollowerControls";
import type { AccountIdentity } from "../../../../shared/account/AccountHeader";

type AdminAccountCommentsProps = {
	account?: AccountIdentity;
};

export const AdminAccountComments = ({ account }: AdminAccountCommentsProps) => {
	if (!account) {
		return (
			<div data-testid="admin-account-comments" className="flex flex-col">
				<CenteredSpinner className="h-[200px]" />
			</div>
		);
	}

	return <LoadedAdminAccountComments account={account} />;
};

const LoadedAdminAccountComments = ({ account }: { account: AccountIdentity }) => {
	const { comments, commentsLoading, createComment, createCommentLoading } = useAccountComments(
		account.id,
		true,
	);
	const followersControl = useAccountFollowers(account.id, true);

	return (
		<div data-testid="admin-account-comments" className="flex flex-col">
			<CommentsSection
				downloadTrackingId="account-admin-comments-download"
				entityType="Account"
				exportEntityType="account"
				comments={comments}
				commentsLoading={commentsLoading}
				createComment={createComment}
				createCommentLoading={createCommentLoading}
				draftKey={messageDraftKey("accounts", account.id)}
				commentDownloadHeader={`Account For ${account.displayName}`}
				headerEnd={
					<AdminFollowerControls
						{...followersControl}
						manageFollowersSubtext="Followers will receive email notifications for all comments and changes to the status of this account"
						agencyId={account.agencyId}
						trackingPrefix="account-admin-comments-follow"
					/>
				}
			/>
		</div>
	);
};
